// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationArrowCcw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="m11.46 2.182.792.639a.5.5 0 0 1 .082.695L10.42 6.04l.004.045a7.999 7.999 0 0 1 9.571 8.073 8 8 0 0 1-15.982.24.477.477 0 0 1 .486-.498l.892.003a.534.534 0 0 1 .518.502 6.108 6.108 0 1 0 4.718-6.428l.006.052 2.438 1.957a.5.5 0 0 1 .058.725l-.676.749a.5.5 0 0 1-.685.054L7.021 7.687a.5.5 0 0 1-.075-.703l3.81-4.727a.5.5 0 0 1 .703-.075z"
    />
  </svg>
);
export default SvgNavigationArrowCcw;
